import React from "react";

const SuccessBoxIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 62 61" fill="none">
      <path
        d="M61.4774 4.14593C51.5675 1.29789 41.2967 -0.0968778 30.9862 0.00522512C20.6757 -0.0968778 10.4049 1.29789 0.494995 4.14593L0.494995 56.8541C10.4049 59.7021 20.6757 61.0969 30.9862 60.9948C41.2967 61.0969 51.5675 59.7021 61.4774 56.8541V4.14593Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.9026 37.1513L39.9302 26.1237L37.6535 23.8497L28.9026 32.6006L24.0011 27.8744L21.7244 30.1512L28.9026 37.1513ZM30.478 14.3975C33.5938 14.3975 36.6396 15.3214 39.2303 17.0525C41.821 18.7835 43.8402 21.2439 45.0325 24.1225C46.2249 27.0011 46.5369 30.1687 45.929 33.2246C45.3211 36.2805 43.8207 39.0876 41.6175 41.2908C39.4144 43.494 36.6073 44.9944 33.5514 45.6022C30.4955 46.2101 27.3279 45.8981 24.4493 44.7057C21.5707 43.5134 19.1103 41.4942 17.3792 38.9035C15.6482 36.3128 14.7243 33.267 14.7243 30.1512C14.7156 28.08 15.1171 26.0275 15.9057 24.1122C16.6943 22.197 17.8544 20.4568 19.319 18.9922C20.7836 17.5276 22.5238 16.3676 24.439 15.5789C26.3543 14.7903 28.4067 14.3888 30.478 14.3975Z"
        fill="white"
      />
    </svg>
  );
};

SuccessBoxIcon.defaultProps = {
  width: 62,
  height: 61,
  fill: "#E31C79",
};

export default SuccessBoxIcon;
